module.exports = __webpack_public_path__ + "img/ring_r_l_null_null@2x.a8beca8f.png";